import axios from 'axios';
import apiConfig from '../../api.config';

export default function getPaperlessUserHotels(hotelIds, userEmail) {
  const {
    host,
    URIs: { updatePaperlessUserHotels },
  } = apiConfig;

  const data = {
    hotelIds,
    userEmail,
  };

  const uri = `${host}${updatePaperlessUserHotels}`;

  return axios.put(uri, data).then(res => res.data);
}
